export default function Terms() {
  return (
    <div className="max-w-3xl mx-auto px-6 lg:px-10 py-20">
      <p className="overline text-gold mb-3">LEGAL</p>
      <h1 className="font-display text-4xl md:text-6xl tracking-tight mb-8">Terms & Conditions</h1>
      <p className="text-sm text-neutral-500 mb-10">Last updated: February 2026</p>
      <div className="space-y-6 text-neutral-700 dark:text-neutral-300 leading-relaxed">
        <p>By using rangmohor.gifts you accept these terms. Please read them before placing an order.</p>
        <h2 className="font-display text-2xl mt-8">Orders & pricing</h2>
        <p>All orders are subject to acceptance and availability. Prices are in Indian Rupees (₹) and include applicable taxes. Shipping is calculated at checkout.</p>
        <h2 className="font-display text-2xl mt-8">Returns & exchanges</h2>
        <p>Unopened, non-personalized gifts may be exchanged within 7 days of delivery. Personalized items, edibles, and candles are final sale. Return shipping is the customer's responsibility unless the item arrived damaged.</p>
        <h2 className="font-display text-2xl mt-8">Handmade variations</h2>
        <p>Because our pieces are made by hand, slight variations in colour, grain, and finish are natural and celebrated — no two pieces are perfectly identical.</p>
        <h2 className="font-display text-2xl mt-8">Intellectual property</h2>
        <p>All photography, illustrations, and copy on this site are the property of Rang Mohor Atelier and may not be reproduced without written permission.</p>
        <h2 className="font-display text-2xl mt-8">Governing law</h2>
        <p>These terms are governed by the laws of India. Disputes will be settled in the courts of Jaipur, Rajasthan.</p>
      </div>
    </div>
  );
}
